import scrollMonitor from 'scrollmonitor';
import StickySidebar from 'sticky-sidebar';
import toArray from './../../scripts/to-array';
import classnameToggle from './../../scripts/classname-toggle';

toArray(document.querySelectorAll('[data-component="careers-detail"]')).forEach((component) => {
  const watcher = scrollMonitor.create(component);
  const gallery = component.querySelector('[data-gallery]');
  const apply = component.querySelector('[data-apply]');

  function visibilityChecker() {
    classnameToggle(gallery, 'is-sticky', watcher.isFullyInViewport);
    classnameToggle(gallery, 'is-top-positioned', watcher.isBelowViewport);
  }

  watcher.stateChange(visibilityChecker);
  visibilityChecker();

  if (apply) {
    new StickySidebar(apply); // eslint-disable-line no-new
  }
});
